<template>
  <div class="visak-blok" v-if="visak > 0">
    <span class="visak-tekst">
      prelazi {{ vrsta || 'limit' }} za {{ iznos(visak) }} € — višak se oporezuje kao plaća
    </span>
    <span v-if="!odluka" class="cekanje">čeka odluku</span>
    <span v-else-if="odluka === 'odobri'" class="odobreno">odobreno: {{ iznos(visak) }} € ide u bruto plaću</span>
    <span v-else class="odbijeno">odbijeno: višak se ne prenosi</span>
    <div class="odluka">
      <button type="button" class="gumb-odobri" :class="{ izabran: odluka === 'odobri' }" @click.stop="$emit('odluka', 'odobri')">
        Odobri: dodaj višak {{ iznos(visak) }} € u bruto plaću
      </button>
      <button type="button" class="gumb-odbij" :class="{ izabran: odluka === 'odbij' }" @click.stop="$emit('odluka', 'odbij')">
        Odbij: višak se ne prenosi
      </button>
    </div>
  </div>
</template>

<script>
// Poruka o visku preko limita i odluka korisnika (odobri / odbij). Visak se NIKAD ne dodaje sam.
export default {
  name: 'neoporezivovisak',
  props: {
    visak: { type: Number, default: 0 },
    vrsta: { type: String, default: '' },
    odluka: { type: String, default: null }
  },
  methods: {
    iznos (n) {
      const x = Math.round((Number(n) || 0) * 100) / 100
      const s = x.toFixed(2).split('.')
      return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + s[1]
    }
  }
}
</script>

<style scoped>
.visak-blok { font-size: 12px; margin-top: 3px; max-width: 340px; text-align: left; }
.visak-tekst { color: #c62828; font-weight: 500; }
.cekanje { display: inline-block; background: #fff3cd; color: #8d6e00; border: 1px solid #ffe082; border-radius: 10px; padding: 0 8px; font-size: 11px; font-weight: 700; }
.odobreno { color: #2e7d32; font-weight: 700; }
.odbijeno { color: rgba(0,0,0,.6); font-weight: 700; }
.odluka { display: flex; gap: 6px; flex-wrap: wrap; margin-top: 5px; }
.odluka button { font-size: 12px; padding: 4px 8px; background: #fff; border: 1px solid; border-radius: 4px; text-align: left; cursor: pointer; }
.gumb-odobri { color: #2e7d32; border-color: #2e7d32 !important; }
.gumb-odbij { color: #c62828; border-color: #c62828 !important; }
.gumb-odobri.izabran { background: #2e7d32 !important; color: #fff; }
.gumb-odbij.izabran { background: #c62828 !important; color: #fff; }
</style>
